import { ReactNode, useEffect } from "react";
import CSS from "./static/css/AccountPage.module.css";
import { useCommonStore } from "../../../../App";

const AccountPage = (
    {
        children,
        className = "",
    }:{
        children?: ReactNode;
        className?: string;
    }
) => {
    const setIsNaviHidden = useCommonStore((state) => state.setIsNaviHidden);
    const setIsHeaderHidden = useCommonStore((state) => state.setIsHeaderHidden);

    useEffect(() => {
        setIsNaviHidden(true);
        setIsHeaderHidden(true);

        return () => {
            setIsNaviHidden(false);
            setIsHeaderHidden(false);
        }
    }, []);

    return(
        <div className={[CSS.l_AccountPage_main, className].filter(Boolean).join(" ")}>
            {children}
        </div>
    )
}

export default AccountPage;